(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-operating-system"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const search = root.querySelector('[data-search]');
      const clear = root.querySelector('[data-clear-search]');
      const cards = [...root.querySelectorAll('[data-card]')];
      const empty = root.querySelector('[data-empty-state]');
      const gate = root.querySelector('[data-access-gate]');
      const dashboard = root.querySelector('[data-dashboard]');
      const accessForm = root.querySelector('[data-access-form]');
      const accessInput = root.querySelector('[data-access-input]');
      const accessError = root.querySelector('[data-access-error]');
      const lockButton = root.querySelector('[data-lock-portal]');
      const storageKey = `ct-os-access-${root.id}`;

      const filterCards = () => {
        const term = search.value.trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const matches = card.dataset.searchTerms.toLowerCase().includes(term);
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        clear.hidden = !term;
        empty.hidden = visible !== 0;
      };

      if (search) search.addEventListener('input', filterCards);
      if (clear) clear.addEventListener('click', () => { search.value = ''; filterCards(); search.focus(); });

      root.querySelectorAll('[data-mission]').forEach((checkbox) => {
        const key = `ct-os-mission-${checkbox.dataset.mission}`;
        checkbox.checked = localStorage.getItem(key) === new Date().toDateString();
        checkbox.addEventListener('change', () => {
          if (checkbox.checked) localStorage.setItem(key, new Date().toDateString());
          else localStorage.removeItem(key);
        });
      });

      const gateEnabled = root.dataset.accessEnabled === 'true' && root.dataset.accessCode.length > 0;
      const unlock = () => { gate.hidden = true; dashboard.removeAttribute('aria-hidden'); };
      const lock = () => { sessionStorage.removeItem(storageKey); gate.hidden = false; dashboard.setAttribute('aria-hidden', 'true'); accessInput.value = ''; accessInput.focus(); };

      if (gateEnabled && sessionStorage.getItem(storageKey) !== 'open') lock();
      else unlock();

      if (accessForm) accessForm.addEventListener('submit', (event) => {
        event.preventDefault();
        if (accessInput.value === root.dataset.accessCode) {
          sessionStorage.setItem(storageKey, 'open');
          accessError.hidden = true;
          unlock();
          search?.focus();
        } else {
          accessError.hidden = false;
          accessInput.select();
        }
      });
      if (lockButton) lockButton.addEventListener('click', lock);
    };

    document.querySelectorAll('[data-ct-os]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-ct-os]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["where-cast-timber-found-a-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadMapbox = () => {
      if (window.mapboxgl) return Promise.resolve();
      if (window.castTimberMapboxPromise) return window.castTimberMapboxPromise;

      window.castTimberMapboxPromise = new Promise((resolve, reject) => {
        if (!document.querySelector('[data-mapbox-stylesheet]')) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = 'https://api.mapbox.com/mapbox-gl-js/v3.27.0/mapbox-gl.css';
          stylesheet.dataset.mapboxStylesheet = 'true';
          document.head.appendChild(stylesheet);
        }

        const existingScript = document.querySelector('[data-mapbox-script]');
        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.27.0/mapbox-gl.js';
        script.dataset.mapboxScript = 'true';
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });

      return window.castTimberMapboxPromise;
    };

    const initializeMaps = async () => {
      try {
        await loadMapbox();
      } catch (exception) {
        document.querySelectorAll('[data-map-error]').forEach((error) => {
          error.hidden = false;
        });
        return;
      }

      document.querySelectorAll('[data-cast-timber-map]').forEach((section) => {
        if (section.dataset.mapInitialized === 'true') return;

        section.dataset.mapInitialized = 'true';
        const canvas = section.querySelector('.cast-timber-map-section__canvas');
        const error = section.querySelector('[data-map-error]');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        try {
          const map = new mapboxgl.Map({
            accessToken: section.dataset.mapToken,
            container: canvas,
            style: section.dataset.mapStyle,
            center: [-98.5, 38.25],
            zoom: isMobile ? 2.15 : 3.15,
            minZoom: 2,
            maxZoom: 14,
            attributionControl: true,
            cooperativeGestures: true,
            pitchWithRotate: false,
            dragRotate: false
          });

          map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
          map.scrollZoom.disable();

          const findLocation = (point) => map
            .queryRenderedFeatures(point)
            .find((feature) => feature.properties && feature.properties.popup_heading && feature.properties.popup_message);

          map.on('click', (event) => {
            const feature = findLocation(event.point);
            if (!feature) return;

            const coordinates = feature.geometry.coordinates.slice();
            const popupContent = document.createElement('div');
            const heading = document.createElement('h3');
            const message = document.createElement('p');

            heading.className = 'cast-timber-map-popup__title';
            heading.textContent = feature.properties.popup_heading;
            message.className = 'cast-timber-map-popup__message';
            message.textContent = feature.properties.popup_message;
            popupContent.append(heading, message);

            while (Math.abs(event.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += event.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            new mapboxgl.Popup({ closeButton: true, closeOnClick: true, offset: 8, maxWidth: '320px' })
              .setLngLat(coordinates)
              .setDOMContent(popupContent)
              .addTo(map);
          });

          map.on('mousemove', (event) => {
            map.getCanvas().style.cursor = findLocation(event.point) ? 'pointer' : '';
          });

          map.on('mouseleave', () => {
            map.getCanvas().style.cursor = '';
          });

          map.on('error', (event) => {
            if (error) error.hidden = true;
          });

          map.on('error', (event) => {
            if (event.error && error) { error.hidden = false; map.once('idle', () => { if (error) error.hidden = true; }); }
          });
        } catch (exception) {
          if (error) error.hidden = false;
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeMaps, { once: true });
    } else {
      initializeMaps();
    }

    document.addEventListener('shopify:section:load', initializeMaps);
  })();

  } catch(e) { console.error(e); }
})();
})();
